import React, { Component } from 'react';
import axios from 'axios'
import UserContext from '../../utils/userContext'
import './feed-highlight.style.css';
import {
    Link,
} from 'react-router-dom'

import { FeedCard } from '../feed-container/feed-container.component'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas);


export default class FeedHighlight extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            tagName: "",
            posts: []
        };
    }


    componentDidMount() {

        // this.setState({ tagName: this.props.tagName });
        this.getHighLightPosts(this.props.tagName);

    }

    getHighLightPosts(tagName) {
        const self = this
        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts${tagName ? `/tag/${tagName}` : ""}/filter/highlight?page=0&limit=4`,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {

                self.setState({ posts: response.data, tagName: tagName })
            })
            .catch(function (response) {

            });

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tagName !== this.props.tagName) {

            this.getHighLightPosts(nextProps.tagName)
        }
    }


    render() {
        return (
            <div className="highlight-wrap">
                <p className="highlight-head">Highlight {this.state.tagName} ประจำสัปดาห์<br />
                    <span className="highlight-subhead">เพราะบางครั้งความรู้ก็อยู่ในรูปแบบตัวหนังสือสุดพิเศษ​ 🙂</span></p>
                <div className="highlight-feed">
                    {
                        this.state.posts ? this.state.posts.map((post, i) => <EachFeedHighlight key={i} post={post} index={i} selectedTag={this.state.tagName} />) : ""
                    }
                </div>
            </div>
        )
    }

}




const EachFeedHighlight = ({ post, index, selectedTag }) => {
    const filteredTag = selectedTag ? post.tags.filter(tag => {
        return tag.tagName === selectedTag
    }) : [];

    const tag = filteredTag.length === 0 ? post.tags : filteredTag


    return (
        <>
            {index < 4 ?
                <div className="highlight-card">
                    <Link className="a-link" to={`/${post.userNicename}/${post.path}`}>
                        <div className="highlight-image" style={{ backgroundImage: `url(${post.coverImage})` }}>
                        </div>
                        <div className="highlight-title ellipsis-two-lines">
                            {post.title}
                        </div>
                    </Link>
                    <div className="highlight-author">
                        <Link to={`/${post.userNicename}/`}>
                            <div className="highlight-author-image" style={{ backgroundImage: `url(${post.authorImage})` }}>
                            </div>
                        </Link>
                        <Link to={`/${post.userNicename}/`}>
                            <div className="highlight-author-name">

                                {post.authorName}

                            </div>
                        </Link>

                    </div>
                    <div class="highlight-detail">
                        <Link className="a-link" to={`/tag/${tag[0].tagName}`}>
                            <div className="highlight-category" style={{ color: tag[0].tagColor2 ? tag[0].tagColor2 : "white", backgroundColor: tag[0].tagColor1 ? tag[0].tagColor1 : "#3c3c3c" }}>
                                {tag[0].tagName}
                            </div>
                        </Link>
                        <div className="highlight-reaction">
                            <div className="highlight-reaction-each">
                                <div style={{ color: "salmon" }}>
                                    <FontAwesomeIcon style={{ color: "salmon" }} icon={['fas', 'heart']} fixedWidth/>
                                </div>
                                <div>
                                    {post.miniheartCount}
                                </div>
                            </div>
                            <div className="highlight-reaction-each">
                                <div style={{ color: "salmon" }}>
                                    <FontAwesomeIcon style={{ color: "#FFC000" }} icon={['fas', 'comment-dots']} fixedWidth/>
                                </div>
                                <div>
                                    {post.commentCount}
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                : ""}
        </>
    )
}


class FeedHighlightSideMenu extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            posts: []
        };
    }

    componentDidMount() {
        const self = this
        axios({
            method: 'get',
            url: "https://www.borntodev.com/wp-json/devblog/v1/posts/filter/highlight?page=0&limit=4",
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                self.setState({ posts: response.data })
            })
            .catch(function (response) {

            });
    }

    render() {
        return (
            <div className="highlight-sb-wrap">
                <p className="highlight-sb-head">บทความเด็ดประจำสัปดาห์ 🔥</p>
                {
                    this.state.posts ? this.state.posts.map((post, i) => <EachFeedHighlightSideMenu key={i} post={post} index={i} />) : ""
                }
            </div>
        )
    }
}

const EachFeedHighlightSideMenu = ({ post, index }) => {
    return (
        <div className="feed-highlight-sm-wrap">
            <Link to={`/${post.userNicename}/`}>
                <div className="feed-highlight-sm-author-image" style={{ backgroundImage: `url(${post.authorImage})` }}>
                </div>
            </Link>
            <div className="feed-highlight-sm-detail ">
                <Link to={`/${post.userNicename}/${post.path}`}>
                    <div className="feed-highlight-sm-name ellipsis-two-lines">
                        {post.title}
                    </div>
                </Link>
                <div className="feed-highlight-sm-tag-wrap">
                    {post.tags.map((tag, i) => <div className="feed-highlight-sm-tag"><Link className="a-link" to={`/tag/${tag.tagName}`}>#{tag.tagName}</Link></div>)}
                </div>
            </div>
        </div>
    )
}



class FeedHighlightSideLast extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            posts: []
        };
    }

    componentDidMount() {
        const self = this
        axios({
            method: 'get',
            url: "https://www.borntodev.com/wp-json/devblog/v1/posts/filter/next?page=0&limit=3",
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                self.setState({ posts: response.data })
            })
            .catch(function (response) {

            });
    }

    render() {
        return (
            <div className="highlight-last">

                {
                    this.state.posts.length !== 0 ? <><p className="highlight-last-head">อ่านอะไรต่อไปดี ?</p>{this.state.posts.map((post, i) => <FeedCard key={i} post={post} index={i} />)}</> : ""
                }
            </div>
        )
    }
}

// export default FeedHighlight;

export { FeedHighlightSideMenu, FeedHighlightSideLast };
